<form [formGroup]="form" (ngSubmit)="submitForm()">
  <aux-modal [primaryButtonType]="'submit'">
    <div class="flex min-w-[520px] max-w-[520px] flex-col gap-4">
      <span class="order-first w-full max-w-[520px]">
        Send email to permissioned user(s) requesting a change order to reconcile any differences
        between the Auxilius PO Amount and the latest PO Report’s PO Amount. Select the related
        purchase order and permissioned users to email. Make sure to include a note to user(s) too.
      </span>
      <div class="order-first">
        <label for="role" class="mb-1 block text-xs">
          PO #
          <span class="font-bold text-aux-error">*</span>
        </label>
        <ng-select
          class="tabular-nums"
          appendTo="body"
          formControlName="po_number"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [items]="poNumberItems()"
          [clearable]="false"
          (change)="onPONumberChange($event)"
          auxFormError
        />
      </div>
      <div class="order-first">
        <label for="role" class="mb-1 block text-xs">
          Vendor Contract
          <span class="font-bold text-aux-error">*</span>
        </label>
        <ng-select
          class="tabular-nums"
          appendTo="body"
          formControlName="vendor"
          [items]="vendorItems()"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [clearable]="false"
          [disabled]="true"
          auxFormError
        />
      </div>
      <aux-multi-select-dropdown
        label="User(s)"
        placeholder="Select"
        [requiredLabel]="true"
        class="order-first max-w-[520px] tabular-nums"
        appendTo="body"
        formControlName="users"
        [bindLabel]="'label'"
        [bindValue]="'value'"
        [items]="userItems()"
        [multiple]="true"
        [searchable]="true"
        auxFormError
      />
      <div class="order-last w-full max-w-[520px]">
        <aux-input
          [textArea]="true"
          [rows]="5"
          label="Notes"
          class="text-xs"
          resize="none"
          placeholder="Notes..."
          formControlName="notes"
        />
      </div>
    </div>
  </aux-modal>
</form>
